export default {
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
  FORGOT_PIN: 'FORGOT_PIN',
  EMAIL_SENT: 'EMAIL_SENT',
};



// WEBPACK FOOTER //
// ./constants/modalContent.js